import React,{Fragment} from 'react'
import Header from '../component/Header';
import Empleadolist from '../component/Empleadolist';
import Footer from '../component/Footer';
function Empleados() {
   
  return (
    <Fragment>
         <Header />
            <div className='container-fluid mt-5'>
                <div className='col-8 m-auto w__full'>
                    <h3 className='fw-light letra__'>Empleado</h3>
                    <p> Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                        Quaerat vitae tempora recusandae. Aliquam quaerat eius vero deleniti,
                        doloribus nulla et minus cum voluptatibus totam eos repellendus
                        quibusdam nam eaque? Harum. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                        Quaerat vitae tempora recusandae. Aliquam quaerat eius vero deleniti,
                        doloribus nulla et minus cum voluptatibus totam eos repellendus
                        quibusdam nam eaque? Harum.
                    </p>

                <Empleadolist />
                </div>
            </div>
            <Footer />
    </Fragment>
  )
}

export default Empleados